import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import { isMobile } from "detect-touch-device";

let smoother;

class CustomAnimation {
  smoother;

  init() {
    gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

    //this.initSmoothScroll();
    this.initHeaderAnimation();
    //this.initDeviderAnimation();
    this.initFooterAnimation();
  }

  initSmoothScroll = () => {
    if (!isMobile) {
      smoother = ScrollSmoother.create({
        wrapper: ".page",
        content: ".scroll",
        smooth: 1.6,
        effects: true,
        smoothTouch: 0,
        normalizeScroll: true,
        speed: 1,
      });
    }
  }

  getSmoother = () => {
    return smoother;
  };

  initHeaderAnimation = () => {
    gsap.to(".header_animation", {
      scrollTrigger: {
        trigger: ".header",
        start: "top 10%",
        end: "bottom 10%",
        markers: false,
        scrub: true,
      },
      scale: 1.1,
      y: -10,
    });
  };

  initDeviderAnimation = () => {

    gsap.from('.devider', {
      scrollTrigger: {
        trigger: '.content',
        start: 'top bottom',
        end: 'bottom bottom', // Offset hinzufügen (100px überlädt die Berechnung leicht)
        scrub: true,
        markers: false,
      },
      y: 100, // Footer bewegt sich um 100px nach oben
      ease: 'none',
    });
  }

  initFooterAnimation = () => {

    gsap.from('.footer', {
      scrollTrigger: {
        trigger: '.footer',
        start: 'top bottom',
        end: 'bottom+=100px bottom', // Offset hinzufügen (100px überlädt die Berechnung leicht)
        scrub: true,
        markers: false,
      },
      y: -100, // Footer bewegt sich um 100px nach oben
      ease: 'none',
    });
  }

  onResize = () => {
    jQuery(window)
      .resize(function () {

      })
  };
}

export default CustomAnimation;
